import React from 'react'

const NotFound = () => {
  return (
    <div className='coming-soon'>
    COMING SOON
    </div>
  )
}

export default NotFound